import React from 'react';

const Managers = () => {
  return (
    <div>
      <h4>Managers</h4>
      <p>This page is under construction.</p>
    </div>
  );
};

export default Managers;
